import {ACTIVE_PROJECT_STORE_PATH} from '../constants'
import {addNamespace} from '@/store/helpers'

// To be used only inside vuex modules
export const _actions = {
  GET_COMPONENTS: 'getComponents',
  BUILD_AVAILABLE_FILTER_CRITERIA: 'buildAvailableFilterCriteria'
}

// To be used publicly outside vuex modules
export const ACTIONS = addNamespace(
  ACTIVE_PROJECT_STORE_PATH,
  _actions
)
